import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "courseFields", "errorMessage" ]

  connect() {
    // Set initial state based on checkbox
    const checkbox = this.element.querySelector('input[type="checkbox"][name*="includes_teach_safe"]')
    if (checkbox) {
      this.updateVisibility(checkbox.checked)
    }
    
    // Find the form and add submit handler
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', this.validateBeforeSubmit.bind(this))
    }
    
    // Add change listeners to course checkboxes to clear error when selected
    const courseCheckboxes = this.element.querySelectorAll('input[type="checkbox"][name*="teach_safe_course_id_"]')
    courseCheckboxes.forEach(cb => {
      cb.addEventListener('change', this.clearErrorOnCourseSelection.bind(this))
    })
  }

  disconnect() {
    // Clean up form submit listener
    const form = this.element.closest('form')
    if (form) {
      form.removeEventListener('submit', this.validateBeforeSubmit.bind(this))
    }
  }

  validateBeforeSubmit(event) {
    const checkbox = this.element.querySelector('input[type="checkbox"][name*="includes_teach_safe"]')
    
    // Only validate if Teach Safe is checked
    if (checkbox && checkbox.checked) {
      // Find all Teach Safe course checkboxes
      const courseCheckboxes = this.element.querySelectorAll('input[type="checkbox"][name*="teach_safe_course_id_"]')
      const atLeastOneSelected = Array.from(courseCheckboxes).some(cb => cb.checked)
      
      if (!atLeastOneSelected) {
        event.preventDefault()
        event.stopPropagation()
        this.showError("At least one Teach Safe course must be selected when Teach Safe is included.")
        // Scroll to error message
        if (this.hasErrorMessageTarget) {
          this.errorMessageTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return false
      }
    }
    
    // Clear error if validation passes
    this.hideError()
    return true
  }

  toggleCourseFields(event) {
    // Get the checkbox from the event (event delegation from parent)
    let checkbox = event.target
    // If the event target isn't the checkbox, find it
    if (checkbox.type !== 'checkbox' || !checkbox.name || !checkbox.name.includes('includes_teach_safe')) {
      checkbox = this.element.querySelector('input[type="checkbox"][name*="includes_teach_safe"]')
    }
    if (checkbox) {
      this.updateVisibility(checkbox.checked)
      // Clear error when checkbox is toggled
      this.hideError()
    }
  }

  updateVisibility(show) {
    if (this.hasCourseFieldsTarget) {
      this.courseFieldsTarget.style.display = show ? "block" : "none"
    }
  }

  showError(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.style.display = "block"
    } else {
      // Create error message element if it doesn't exist
      const errorDiv = document.createElement('div')
      errorDiv.className = "Panel  Panel--alert  p1  mb2  u-textSmall"
      errorDiv.textContent = message
      errorDiv.setAttribute('data-teach-safe-course-selection-target', 'errorMessage')
      if (this.hasCourseFieldsTarget) {
        this.courseFieldsTarget.insertBefore(errorDiv, this.courseFieldsTarget.firstChild)
      }
    }
  }

  hideError() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.style.display = "none"
    }
  }

  clearErrorOnCourseSelection(event) {
    // Clear error when a course is selected
    if (event.target.checked) {
      this.hideError()
    }
  }
}

